import React, { useContext, useState, useEffect } from 'react'
import { StateContext } from "../App";
import './notification.css'
import axios from 'axios'

function Notification() {
    const [notifications, setNoti] = useState([])
    const { state, dispatch } = useContext(StateContext);

    useEffect(() => {state.user && setNoti(state.user.notifications)}, [state.user] )
    


    const clearNotification = (comment_id) => {
        const user_id = state.user._id;
        // alert(`About to delete Notification with Id --> ${user_id}/${comment_id}`)

        // dispatch({ type: 'SET_LOADING', payload: true })
       
        
        axios.delete(`/admin/notification/${user_id}/${comment_id}`)
        .then(res => {
            // dispatch({ type: 'SET_LOADING', payload: false})
            // alert("Notification Deleted!")
            // dispatch({ type: "DELETE_NOTIFICATION", payload: res.data.user._id });
            setNoti(ns => ns.filter(n => n._id !== comment_id))
        })
        .catch(e => {
            dispatch({ type: 'SET_LOADING', payload: false });
            console.log(e);
        })
    }
     

    return (
        <div className="Notification">
           <h4>Notifications</h4>
           <div className="container">
               <div className="row">
                   <div className="col s12 m12 l12">
                        {
                            notifications && notifications.length > 0 ?
                            notifications.map(n => {
                                    return (
                                    <div className="card grey darken-4">
                                        <div className="card-content">
                                            <p>{ n.message }</p>
                                        </div>
                                        <div className="card-footer">
                                            <a onClick={() => clearNotification(n._id)} className="btn clear_btn grey darken-3">
                                            Clear
                                            </a>
                                        </div>
                                    </div>
                                    )
                                })
                            :
                            (
                                <div className="card grey darken-3">
                                   <div className="card-content">
                                        <p>No New Notification!</p>
                                    </div>
                                </div>
                            )
                        }
                   </div>
               </div>
           </div>
        </div>
    )
}

export default Notification
